module.exports = __webpack_public_path__ + "static/img/kh-22.d594cb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-22.png
// module id = WCKj
// module chunks = 5